// removed by extract-text-webpack-plugin
module.exports = {"home-header-color":"#1b8ecc","header":"_3gUEa5yqzEDCA0yqPcPpET"};


//////////////////
// WEBPACK FOOTER
// ./src/views/home/style.css
// module id = 657
// module chunks = 0